module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/refresh-3280d7a08b77532d8659e2752592be9a.svg";